import script from "./UsuariosCuadres.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosCuadres.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosCuadres.vue?vue&type=style&index=0&id=2f7a0181&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7a0181"]])

export default __exports__